export interface LoyaltyCardUpdateAmount {
  ambassadorId?: string;
  loyaltycard: string;
  user: string;
  amount: number;
  merchantid: string; // external location id
  locationId?: number;
}
